import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import ButtonActivate from '../../../Buttons/ButtonAction';
import ButtonDetails from '../../../Buttons/AuthButton';
import ButtonBase from '../../../Buttons/ButtonBase';
import { HashLink } from 'react-router-hash-link';
import * as ROUTES from '../../../../routes';
import { Link } from 'react-router-dom';

import moment from 'moment';
import 'moment/locale/es';

import './Free.scss';
import FirmsMemberships from './Memberships/FirmsMemberships';
import LawyerMemberships from './Memberships/LawyerMemberships';

// const more = '/img/home/more.svg';
// const two = '/img/home/two.svg';
const profile = '/img/home/profile.svg';
const rewardYellow = '/img/home/completo.svg';
const rewardGray = '/img/home/desabilitado.svg';
const rewardMint = '/img/home/completo-adicional.svg';

const useStyles = makeStyles({
  card: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  cardWelcome: {
    maxWidth: 1040,
    minHeight: 88,
    padding: 24,
    margin: '0 auto 24px',
    '@media (max-width: 767px)' : {
      padding: 16
    },
  },
  cardFeature: {
    maxWidth: 400,
    display: 'flex',
    alignItems: 'center',
    marginRight: 16,
    '&:last-child': {
      marginRight: 0,
    },
    '@media (max-width: 1023px)': {
      marginRight: 0,
      maxWidth: 816,
      '&:first-child': {
        marginBottom: 24,
      },
    },
  },
  cardTour: {
    width: 216,
    alignItems: 'center',
    margin: '16px 0',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

moment.locale('es');
let startDate = moment().startOf('month').format('D');
let endDate = moment().endOf('month').format('D [de] MMMM');

const tituloNombre = (auth) => {
  switch (auth.gradeStudy) {
    case 'Licenciatura':
      return 'Lic.';
    case 'Mestría': {
      if (auth.genero === 'male') {
        return 'Mtro.';
      } else if (auth.genero === 'female') {
        return 'Mtra.';
      }
      return null;
    }
    case 'Especialidad':
      return 'Esp.';
    case 'Doctorado': {
      if (auth.genero === 'male') {
        return 'Dr.';
      } else if (auth.genero === 'female') {
        return 'Dra.';
      }
      return null;
    }

    default:
      return '';
  }
};

function FreeMember(props) {
  const { auth } = props;
  const classes = useStyles();

  let lawyerAwardsArray;
  let lawfirmAwardsArray;
  if (auth && auth.awardPerfil) {
    const {
      look,
      about,
      holder,
      collaborators,
      experience,
      contact,
      site,
    } = auth.awardPerfil;
    lawyerAwardsArray = [look, about, experience, contact, site];
    lawfirmAwardsArray = [
      look,
      about,
      holder,
      collaborators,
      experience,
      contact,
      site,
    ];
  }
  let aditionalArray;
  if (auth.awardAditional) {
    const {
      cost,
      pictures,
      videos,
      shareProfile,
      highQualification,
    } = auth.awardAditional;
    aditionalArray = [cost, pictures, videos, shareProfile, highQualification];
  }

  

  const countViews =
    auth.analyticsViewProfile &&
    auth.analyticsViewProfile.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .utc()
        .isBetween(moment().startOf('month'), moment().endOf('month'))
    ).length;

  const calculateProfileAchievements = () => {
    let quantity;
    if (auth.awardPerfil) {
      if (auth.role === 'lawyer') {
        quantity = lawyerAwardsArray.filter((element) => element);
      } else {
        quantity = lawfirmAwardsArray.filter((element) => element);
      }
      return quantity.length;
    } else {
      return 0;
    }
  };

  const calculateAditionalAchievements = () => {
    let quantity;
    if (auth.awardAditional) {
      quantity = aditionalArray.filter((element) => element);
      return quantity.length;
    } else {
      return 0;
    }
  };

  let PROFILE_LIMIT;
  if (auth.role === 'lawyer') {
    PROFILE_LIMIT = 5;
  } else {
    PROFILE_LIMIT = 7;
  }

  const ACHIEVEMENTS_LIMIT = 5;

  return (
    <div className="homeFree">
      <main className="homeFree-main">
        <div className="homeFree-header">
          <Card className={`${classes.card} ${classes.cardWelcome}`}>
            <div className="card-welcome">
              <div>
                <p className="card-username mainTitle">
                  ¡Hola,{' '}
                  {auth && auth.role === 'lawyer' ? tituloNombre(auth) : null}{' '}
                  {auth.role === 'lawyer'
                    ? auth.name
                    : auth.officeName && auth.officeName}
                  !
                </p>
                <p>Te presentamos tu resumen de actividad</p>
              </div>

              <Link to={ROUTES.MEMBERSHIPS_LAWYERS}>
                <ButtonActivate variant="tertiary" className="activate">
                  ¡Mejora tu plan!
                </ButtonActivate>
              </Link>
            </div>
          </Card>
        </div>

        <div className="homeFree-grades">
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <div className="homeFree-card card-visits">
                <div className="card-visits-content">
                  <p className="title title-22">Visitas al perfil</p>
                  {/*               <p className="number">{auth.views}</p>
                   */}{' '}
                  <p className="number">{countViews ? countViews : '0'}</p>
                  <p className="subtitle subtitle-20">{`Del ${startDate} al ${endDate}`}</p>
                  <img className="icon" src={profile} alt="usuario" />
                  <Link to="/dashboard/analytics" className="link">
                    Ver más
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} lg={8}>
              <div className="homeFree-card card-features">
                <div className="card-features-content">
                  <p className="title title-22">
                    Beneficios de tu membresía Freemium
                  </p>
                  <Grid container justify="space-between">
                    <Grid item xs={12} md={6}>
                      <div className="feature">
                        <img src="/img/icons/profile-blue.svg" alt="perfil" />
                        <p>Perfil profesional público</p>
                      </div>
                      <div className="feature">
                        <img src="/img/icons/preguntas.svg" alt="preguntas" />
                        <p>Acceso a la comunidad de abogados</p>
                      </div>
                      <div className="feature">
                        <img src="/img/icons/phone.svg" alt="soporte" />
                        <p>
                          Soporte vía telefónica, WhatsApp o email por parte de
                          nuestros asesores
                        </p>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <div className="feature">
                        <img
                          src="/img/icons/analytics-blue.svg"
                          alt="análisis"
                        />
                        <p>Análisis de resultados en tu cuenta</p>
                      </div>
                      {/* <div className="feature">
                        <img src="/img/icons/web.svg" alt="redes" />
                        <p>Enlace del perfil a redes sociales y WhatsApp</p>
                      </div> */}
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="homeFree-typeOfMembership">
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <div className="homeFree-card card-membership">
                <div className="card-membership-content">
                  <div className="membership-name">
                    <div className="membership-name_free">Membresía Freemium</div>
                    <div>Plan gratuito</div>
                  </div>
                  <small className="subtitle-14">Actualmente activa</small>
                  <div className="membership-details">
                    <div
                      style={{
                        display: 'flex',
                        //marginTop: 16,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div className="data-wrapper">
                        <p className="text">Monto membresía</p>
                        <p className="subtitle">$0.-MXN</p>
                      </div>
                      <div className="data-wrapper">
                        <p className="text">Método de pago</p>
                        <p className="subtitle">Sin método de pago</p>
                      </div>
                      <div className="data-wrapper">
                        <p className="text">Monto total</p>
                        <p className="subtitle">$0.-MXN</p>
                      </div>
                    </div>
                  </div>
                  <Link
                    to={ROUTES.MEMBERSHIPS_LAWYERS}
                  >
                    <ButtonBase variant="primary">
                      ¡Conoce las membresías!
                    </ButtonBase>
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <div className="homeFree-card card-rewards">
                <div className="card-rewards-content">
                  <p className="title title-22">Logros obtenidos</p>
                  <HashLink smooth to="/dashboard/perfil/#progress">
                    <span className="link">Ver más</span>
                  </HashLink>
                  <div className="reward-list">
                    <div>
                      <p className="title title-14">Recompensas del perfil</p>
                      <div className="results">
                        <div className="reward-icons">
                          {auth.role === 'lawyer'
                            ? lawyerAwardsArray &&
                              lawyerAwardsArray
                                .sort()
                                .reverse()
                                .map((element, index) => {
                                  if (element) {
                                    return (
                                      <img
                                        className="reward"
                                        src={rewardYellow}
                                        alt="logro obtenido"
                                        key={index}
                                      />
                                    );
                                  } else {
                                    return (
                                      <img
                                        className="reward"
                                        src={rewardGray}
                                        alt="logro no obtenido"
                                        key={index}
                                      />
                                    );
                                  }
                                })
                            : lawfirmAwardsArray &&
                              lawfirmAwardsArray
                                .sort()
                                .reverse()
                                .map((element, index) => {
                                  if (element) {
                                    return (
                                      <img
                                        className="reward"
                                        src={rewardYellow}
                                        alt="logro obtenido"
                                        key={index}
                                      />
                                    );
                                  } else {
                                    return (
                                      <img
                                        className="reward"
                                        src={rewardGray}
                                        alt="logro no obtenido"
                                        key={index}
                                      />
                                    );
                                  }
                                })}
                        </div>
                        <span className="title title-14">
                          {calculateProfileAchievements()}/{PROFILE_LIMIT}
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="title title-14">
                        Recompensas adicionales
                      </p>
                      <div className="results">
                        <div className="reward-icons">
                          {lawfirmAwardsArray &&
                            aditionalArray &&
                            aditionalArray
                              .sort()
                              .reverse()
                              .map((element, index) => {
                                if (element) {
                                  return (
                                    <img
                                      className="reward"
                                      src={rewardMint}
                                      alt="logro obtenido"
                                      key={index}
                                    />
                                  );
                                } else {
                                  return (
                                    <img
                                      className="reward"
                                      src={rewardGray}
                                      alt="logro no obtenido"
                                      key={index}
                                    />
                                  );
                                }
                              })}
                        </div>
                        <span className="title title-14">
                          {calculateAditionalAchievements()}/
                          {ACHIEVEMENTS_LIMIT}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="homeFree-banner">
          <p>
            Con las membresías Premium obtén todos los beneficios, <b>¡conócelas!</b>
          </p>
          <Link
            to={ROUTES.MEMBERSHIPS_LAWYERS}
          >
            <ButtonDetails variant="secondary" style={{ color: '#10587f' }}>
              Ver membresías
            </ButtonDetails>
          </Link>
        </div>

        <div className="homeFree-memberships">
          {auth && auth.role && auth.role === 'lawyer' && <LawyerMemberships />}
          {auth && auth.role && auth.role === 'lawFirm' && <FirmsMemberships />}
        </div>
      </main>
    </div>
  );
}

export default FreeMember;
